// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"kH","header":"kI","description":"kJ","cta":"kK"};